"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayVoucherToJSON = exports.GiveawayVoucherFromJSONTyped = exports.GiveawayVoucherFromJSON = exports.instanceOfGiveawayVoucher = void 0;
var runtime_1 = require("../runtime");
var EntityMetadata_1 = require("./EntityMetadata");
var VoucherOwner_1 = require("./VoucherOwner");
var VoucherReward_1 = require("./VoucherReward");
var VoucherStatus_1 = require("./VoucherStatus");
/**
 * Check if a given object implements the GiveawayVoucher interface.
 */
function instanceOfGiveawayVoucher(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "owner" in value;
    isInstance = isInstance && "reward" in value;
    return isInstance;
}
exports.instanceOfGiveawayVoucher = instanceOfGiveawayVoucher;
function GiveawayVoucherFromJSON(json) {
    return GiveawayVoucherFromJSONTyped(json, false);
}
exports.GiveawayVoucherFromJSON = GiveawayVoucherFromJSON;
function GiveawayVoucherFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, VoucherStatus_1.VoucherStatusFromJSON)(json['status']),
        'expiresAt': !(0, runtime_1.exists)(json, 'expiresAt') ? undefined : (json['expiresAt'] === null ? null : new Date(json['expiresAt'])),
        'claimedAt': !(0, runtime_1.exists)(json, 'claimedAt') ? undefined : (json['claimedAt'] === null ? null : new Date(json['claimedAt'])),
        'owner': (0, VoucherOwner_1.VoucherOwnerFromJSON)(json['owner']),
        'reward': (0, VoucherReward_1.VoucherRewardFromJSON)(json['reward']),
        'metadata': !(0, runtime_1.exists)(json, 'metadata') ? undefined : (0, EntityMetadata_1.EntityMetadataFromJSON)(json['metadata']),
    };
}
exports.GiveawayVoucherFromJSONTyped = GiveawayVoucherFromJSONTyped;
function GiveawayVoucherToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'status': (0, VoucherStatus_1.VoucherStatusToJSON)(value.status),
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt === null ? null : value.expiresAt.toISOString()),
        'claimedAt': value.claimedAt === undefined ? undefined : (value.claimedAt === null ? null : value.claimedAt.toISOString()),
        'owner': (0, VoucherOwner_1.VoucherOwnerToJSON)(value.owner),
        'reward': (0, VoucherReward_1.VoucherRewardToJSON)(value.reward),
        'metadata': (0, EntityMetadata_1.EntityMetadataToJSON)(value.metadata),
    };
}
exports.GiveawayVoucherToJSON = GiveawayVoucherToJSON;
